import { Text, TextHighlight, TextSize } from '@focaldata/cin-ui-components'
import React from 'react'

interface Props {
  details: string
}

const LaunchErrorDetails: React.FC<Props> = ({ details }) => (
  <details>
    <summary style={{ cursor: 'pointer' }}>Show details</summary>
    <Text size={TextSize.ms} highlight={TextHighlight.Error}>
      {details}
    </Text>
  </details>
)

export default LaunchErrorDetails
